import React from 'react'
import { useThemeContext } from '@/contexts/ThemeContext'
import { NotificationsTable } from '@/molecules/Notifications'

export const NotificationsView: React.FC = () => {
  const { isDarkMode } = useThemeContext()

  return (
    <>
      <div className="mx-auto flex w-full flex-col items-center gap-6 pt-16 sm:w-80 sm:py-28">
        <NotificationsTable isDarkMode={isDarkMode} />
      </div>
    </>
  )
}
